import {
  Button, ButtonColor, ButtonProps, ButtonVariant,
} from '@doveit/lego';
import React from 'react';
import { CTA } from '../../types';
import * as styles from './Step.style';

export interface StepProps {
  position: number,
  title: string,
  description: string,
  cta: CTA & Pick<ButtonProps, 'onClick'>,
}

const Step: React.FC<StepProps> = ({
  position,
  title,
  description,
  cta,
}) => (
  <div css={styles.base}>
    <div css={styles.body}>
      <header css={styles.header}>
        <div css={styles.stepNumber}>
          {position}
        </div>
        <figure css={styles.arrow} />
      </header>

      <div css={styles.title}>
        {title}
      </div>

      <div css={styles.description}>
        {description}
      </div>
    </div>
    <footer>
      <Button
        {...cta}
        color={ButtonColor.DARK}
        variant={ButtonVariant.LIGHT}
      />
    </footer>
  </div>
);

export default Step;
